<script>
import range from 'lodash-es/range'
import { NumberInput } from '@/components/form/number-input'
import PaymentMethodSelect from './PaymentMethodSelect'

export default {
  props: {
    index: {
      type: Number,
      default: null
    },
    method: {
      type: Object,
      default: null
    },
    refCode: {
      type: String,
      default: ''
    },
    amount: {
      type: [String, Number],
      default: null
    },
    fee: {
      type: [String, Number],
      default: null
    },
    feeFree: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    totalFee() {
      return this.amount * (+this.fee / 100)
    },

    amountWithFee() {
      return this.amount + this.totalFee
    },

    isFeeFree() {
      return this.feeFree || (this.method && this.method.isFeeFree)
    }
  },

  watch: {
    method(value) {
      if (value.id === 1) {
        this.$emit('update:refCode', null)
        this.$emit('update:fee', null)
      }
    }
  },

  methods: {
    removeItem() {
      this.$emit('remove', this.index)
    },

    queryFee(queryString, cb) {
      const fees = range(0, 3.25, 0.25)
        .map(n => ({
          value: n + ''
        }))
        .filter(option => option.value.indexOf(queryString) > -1)
      cb(fees)
    }
  },

  render() {
    return (
      <li class={this.$style.root}>
        <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
          <el-col span={null}>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              circle
              onClick={this.removeItem}
            ></el-button>
          </el-col>
          <el-col span={null}>
            <div class={this.$style.orderNumber}>{this.index + 1}.</div>
          </el-col>
          <el-col span={null} style={{ flex: '1' }}>
            <PaymentMethodSelect
              value={this.method}
              placeholder="Select payment"
              style={{ width: '100%', marginBottom: '0.25rem' }}
              onChange={value => {
                this.$emit('update:method', value)
              }}
            ></PaymentMethodSelect>
            <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
              <el-col sm={12} style={{ marginBottom: '0.25rem' }}>
                <label>รหัสอ้างอิง</label>
                <el-input
                  value={this.refCode}
                  placeholder="เช่น 294810"
                  disabled={this.method && this.method.id === 1}
                  onInput={value => {
                    this.$emit('update:refCode', value)
                  }}
                ></el-input>
              </el-col>
              <el-col sm={12} style={{ marginBottom: '0.25rem' }}>
                <label>จำนวน</label>
                <NumberInput
                  value={this.amount}
                  min={0}
                  class={[
                    this.elementUiStyles.numberInput,
                    this.$style.amountInput
                  ]}
                  onInput={value => {
                    this.$emit('update:amount', value)
                  }}
                ></NumberInput>
              </el-col>
            </el-row>
            {!this.isFeeFree && [
              <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
                <el-col sm={12} style={{ marginBottom: '0.25rem' }}>
                  <el-row
                    type="flex"
                    gutter={16}
                    align="middle"
                    style={{ flexWrap: 'wrap' }}
                  >
                    <el-col lg={12}>
                      <label>ค่าธรรมเนียมรวม</label>
                    </el-col>
                    <el-col lg={12} style={{ flex: '1' }}>
                      {/*<el-select
                        value={this.fee}
                        placeholder="%"
                        clearable
                        style={{ width: '100%' }}
                        onChange={value => {
                          this.$emit('update:fee', value)
                        }}
                      >
                        <el-option label="1%" value={0.01}></el-option>
                      </el-select>*/}
                      <el-autocomplete
                        value={this.fee}
                        style={{ width: '100%' }}
                        fetchSuggestions={this.queryFee}
                        onInput={value => {
                          this.$emit('update:fee', value)
                        }}
                      >
                        <template slot="suffix">
                          <div
                            style={{
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            %
                          </div>
                        </template>
                      </el-autocomplete>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col sm={12} style={{ marginBottom: '0.25rem' }}>
                  <el-row
                    type="flex"
                    gutter={16}
                    align="middle"
                    style={{ flexWrap: 'wrap' }}
                  >
                    <el-col lg={12}>
                      <label>คิดเป็นเงิน</label>
                    </el-col>
                    <el-col lg={12} style={{ flex: '1' }}>
                      <el-input
                        value={this.totalFee.toLocaleString('th-TH', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                        readonly
                        class={[
                          this.elementUiStyles.numberInput,
                          this.elementUiStyles.borderlessInput,
                          this.elementUiStyles.boldInput
                        ]}
                      ></el-input>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>,
              <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
                <el-col span={null}>รวม</el-col>
                <el-col
                  span={null}
                  style={{ flex: '1', textAlign: 'right', fontWeight: 'bold' }}
                >
                  {this.amountWithFee.toLocaleString('th-TH', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </el-col>
              </el-row>
            ]}
          </el-col>
        </el-row>
      </li>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}

.orderNumber {
  font-size: 1rem;
  font-weight: bold;
}

.amountInput {
  :global(.el-input__inner) {
    font-size: 1.25rem;
    font-weight: bold;
    text-align: right;
  }
}
</style>

<style
  src="@/assets/scss/modules/element-ui.module.scss"
  lang="scss"
  module="elementUiStyles"
></style>
